import Constants from '../utils/constants';

export default {
    variants: {
        adc: {
            HiZ: {
                code: Constants.VARIANT.ADC.HIZ,
                display: "high-Z"
            },
            PrechargeOn: {
                code: Constants.VARIANT.ADC.PRECHARGE_ON,
                display: "precharge"
            },
            Seq: {
                code: Constants.VARIANT.ADC.SEQ,
                display: "Sequencer"
            }
        },
        driver: {
            LP: {
                code: Constants.VARIANT.DRIVER.LP,
                display: "low power",

                default: {
                    code: Constants.VARIANT.DRIVER.FP,
                    display: "full power"
                }
            }
        }
    }
}